// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  scroll-behavior: auto !important;
}

html {
  height: 100%;
}

body {
  width: 100%;
  min-height: 100%;
  color: #1d1d1b;
  font-family: Arial, sans-serif;
}

* {
  transition: none !important;
  scroll-behavior: auto !important;
}

.top-nav {
  position: fixed;
  top: 0px;
  width: 100%;
  height: 110px;
  z-index: 100;
}
.top-nav .container {
  height: 100%;
  display: flex;
  padding: 20px;
}
.top-nav .logo {
  height: 100%;
  margin-right: 20px;
}
.top-nav .logo img {
  max-width: 100%;
  width: auto;
  height: 100%;
}
.top-nav .search-container {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.top-nav .search-container .search {
  width: 75%;
}
.top-nav .search-container .search .search-input-container {
  width: 100%;
  display: relative;
}
.top-nav .search-container .search .search-input-container input {
  width: 100%;
  border: none;
  padding: 12px 16px;
  border-radius: 20px;
}
.top-nav .search-container .search .search-input-container .icon {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 20px;
  color: #e4e4e4;
  pointer-events: none;
}
.top-nav .controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.top-nav .controls .btn {
  font-size: 12px;
  color: #676767;
}
.top-nav .controls .btn:not(:last-child) {
  margin-right: 10px;
}
.top-nav .controls .btn .fa-solid, .top-nav .controls .btn .spinner-border {
  font-size: 20px;
  margin-bottom: 4px;
}
.top-nav .controls .btn:hover {
  color: #1d1d1b;
}

.side-nav {
  width: 250px;
  padding-top: 20px;
}
.side-nav > ul {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
.side-nav > ul > li {
  border-bottom: 2px solid #e4e4e4;
  margin-bottom: 10px;
  padding-bottom: 5px;
  padding-right: 10px;
  font-weight: bold;
}
.side-nav > ul > li > ul li {
  margin-top: 5px;
  font-weight: normal;
}
.side-nav > ul > li > ul li > ul li {
  margin-top: 5px;
}
.side-nav a {
  text-decoration: none;
  color: #1d1d1b;
  display: flex;
}
.side-nav a .icon {
  margin-left: auto;
}

main {
  margin-top: 110px;
  position: relative;
  display: flex;
}

.main-content {
  flex: 1 1;
  margin-left: 40px;
  padding-top: 20px;
}
.main-content img {
  max-width: 100%;
}

.btn {
  border-radius: 0px;
  border: none;
  outline: none;
  box-shadow: none;
}

.btn-primary {
  color: #ffffff;
  box-shadow: 0px 0px 0px 5px transparent;
}

.btn-secondary {
  color: #fff;
  box-shadow: 0px 0px 0px 5px transparent;
}

.btn-tertiary {
  background-color: #fff;
  border: 2px solid #ccc;
}
.btn-tertiary:hover, .btn-tertiary:focus, .btn-tertiary:focus-visible, .btn-tertiary:active, .btn-tertiary.show {
  border-color: #1d1d1b !important;
  color: #1d1d1b !important;
}

.empty-text {
  text-align: center;
  color: #aaa;
  font-size: 24px;
}

.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  display: flex;
  align-items: center;
}
.form-group label .btn {
  min-width: 24px;
  max-height: 24px;
  font-size: 75%;
}
.form-group .search {
  display: block;
}
.form-group .search .search-input-container {
  position: relative;
}
.form-group .search .search-input-container button {
  position: absolute;
  top: 5px;
  right: 5px;
  height: 28px;
  padding: 0px 5px;
}
.form-group .search .no-results {
  text-align: center;
  padding: 10px;
  color: #aaa;
}
.form-group .search .results {
  background: #ffffff;
  top: 40px;
}
.form-group .search .search-results-button {
  padding: 8px;
}
.form-group .search .search-results-button button {
  display: block;
  width: 100%;
}

.form-label {
  font-weight: bold;
  /*margin-bottom: 5px;*/
}
.form-label .btn {
  padding: 4px 8px;
}

.form-control {
  border-radius: 0px;
}

fieldset {
  margin-bottom: -1rem;
}

h2 {
  color: #1d1d1b;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 40px;
}

.control-panel {
  display: flex;
  align-items: center;
}
.control-panel:last-child {
  border-top: 1px solid #e4e4e4;
  padding-top: 20px;
  margin-top: 20px;
}

#root.not-logged-in {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ddd;
  padding: 20px 0px;
}
#root.not-logged-in img {
  display: block;
  margin: 0px auto 20px auto;
  max-width: 100%;
}
#root.not-logged-in .panel {
  width: 350px;
  max-width: 100%;
  background-color: #ffffff;
  color: #1d1d1b;
  padding: 30px;
}
#root.not-logged-in .btn {
  width: 100%;
}

.spinner-border.inline {
  width: 1em;
  height: 1em;
  border-width: 0.15em;
}
.spinner-border:not(.inline) {
  display: block;
  margin: auto;
}

.search {
  position: relative;
  display: inline-block;
  max-width: 100%;
}
.search input:active, .search input:focus-visible {
  box-shadow: none !important;
  outline: none !important;
}
.search .results {
  display: none;
  position: absolute;
  top: 50px;
  background: #ffffff;
  min-width: 100%;
  color: #1d1d1b;
  z-index: 100;
  overflow: hidden;
  box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1);
}
.search .results.active {
  display: block;
}
.search .no-results {
  padding: 10px;
  text-align: center;
  color: #676767;
}
.search .result {
  display: flex;
  cursor: pointer;
  padding: 10px 15px;
}
.search .result img {
  max-width: 50px;
  max-height: 50px;
  margin-right: 10px;
  border-radius: 5px;
}
.search .result:not(:last-child) {
  border-bottom: 1px solid #e4e4e4;
}
.search .result .details {
  flex: 1 1;
}
.search .result .category {
  color: #676767;
  float: right;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.button-panel .btn:not(:last-child) {
  margin-right: 10px;
}
.button-panel .dropdown {
  display: inline-block;
}

.dropdown-menu {
  border-radius: 0px;
}

.floating-controls > div {
  position: relative;
  height: 100%;
}
.floating-controls > div .btns {
  position: absolute;
  left: 100%;
  top: 0px;
  height: 100%;
  width: 30px;
  display: flex;
  align-items: center;
  display: none;
}

tr:hover .floating-controls .btns {
  display: block;
}

.modal-content {
  border-radius: 0px;
  border: none;
}
.modal-content .btn-close {
  border-radius: 0px;
  border: none;
}

.checkbox-label {
  display: flex;
  align-items: center;
}
.checkbox-label input {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

input[type=checkbox],
input[type=radio] {
  appearance: auto;
}

.modal-backdrop ~ .modal-backdrop {
  z-index: 1055;
}

section {
  background-color: #fff;
  padding: 40px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);
}

table {
  width: 100%;
}
table thead {
  border-bottom: 1px solid black;
}
table th, table td {
  padding: 10px;
}
table.clickable tbody {
  cursor: pointer;
}
table.clickable tbody tr td:first-child {
  border-left: 5px solid transparent;
}

.products-table .id-col {
  width: 110px;
}

.product-details .header {
  display: flex;
  margin-bottom: 40px;
}
.product-details .header .photo {
  margin-right: 40px;
  flex: 1 1;
  max-width: 500px;
}
.product-details .header .key-details {
  flex: 1 1;
}
.product-details .header .key-details table th {
  width: 200px;
  white-space: nowrap;
}
.product-details .buttons {
  margin-top: 40px;
}
.product-details table th {
  width: 200px;
}

.sku-details:not(:last-child) {
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #ccc;
}

.product-details-table th, .product-details-table td {
  vertical-align: top;
}

.nav-tabs .nav-link {
  border: none;
  border-radius: 0px;
  color: #1d1d1b;
  margin: 0px;
}

.supplier-categories-table .business-id-col {
  width: 100px;
}
.supplier-categories-table .num-suppliers-col {
  width: 150px;
}

.suppliers-table .num-products-col {
  width: 150px;
}

.nav-pills .nav-item:not(:last-child) {
  margin-right: 10px;
}
.nav-pills .nav-item .nav-link {
  border-radius: 0px;
}

.page-list:not(:last-child) {
  margin-bottom: 40px;
}
.page-list:last-child {
  margin-top: 40px;
}

table + .page-list {
  margin-top: 40px;
}

.edit-product .product-photo {
  height: 215px;
}
.edit-product .no-photo {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e4e4e4;
  color: #676767;
  padding: 20px;
  height: 100%;
}
.edit-product .product-photo-inner {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}

.export-template-product-fields-table .position-col {
  width: 50px;
  text-align: center;
}
.export-template-product-fields-table td.position-col {
  padding: 15px 10px;
}
.export-template-product-fields-table .actions-col {
  width: 150px;
}

.import-products-table {
  font-size: 10px;
}

.scrolling-table {
  position: relative;
  overflow: auto;
  max-width: 926px;
  max-height: 500px;
}
.scrolling-table th {
  position: sticky;
  top: -1px;
  background-color: #fff;
}

.product-details .nav-tabs {
  margin-bottom: 20px;
}
.product-details .pricing-matrix-table {
  width: 100%;
  margin-top: 20px;
}

.sku-list {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  margin-top: 40px;
  margin-bottom: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.sku-list .nav-item a {
  padding: 10px;
}

.phone-numbers .phone-number {
  display: flex;
  align-items: center;
}
.phone-numbers .phone-number img {
  margin-right: 10px;
}
.phone-numbers .phone-number a {
  flex: 1 1;
}

.pull-right {
  float: right;
}

body.mia {
  background: #daeef8;
  scrollbar-color: #ec1b6b #1d1d1b;
  scrollbar-width: auto;
}
body.mia #root.not-logged-in .panel {
  border-top: 20px solid #ec1b6b;
}
body.mia::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
body.mia::-webkit-scrollbar-track {
  background: #1d1d1b;
}
body.mia::-webkit-scrollbar-thumb {
  background-color: #ec1b6b;
  border-radius: 0px;
  border: 2px solid #1d1d1b;
}
body.mia .top-nav {
  background-color: #daeef8;
}
body.mia .top-nav .container {
  border-bottom: 2px solid #e4e4e4;
}
body.mia .btn-primary {
  background-color: #ec1b6b;
}
body.mia .btn-primary:hover, body.mia .btn-primary:active, body.mia .btn-primary:focus {
  background-color: #ec1b6b;
  box-shadow: 0px 0px 0px 5px #4abede;
}
body.mia .btn-secondary {
  background-color: #f29467;
}
body.mia .btn-secondary:hover, body.mia .btn-secondary:active, body.mia .btn-secondary:focus {
  background-color: #f29467;
  box-shadow: 0px 0px 0px 5px #4abede;
}
body.mia .nav-tabs {
  border-bottom: 1px solid #f29467;
}
body.mia .nav-tabs .nav-link:hover {
  background-color: #daeef8;
}
body.mia .nav-tabs .nav-link.active {
  background-color: #f29467;
}
body.mia .nav-pills .nav-item .nav-link {
  background-color: #ffffff;
  color: #000;
}
body.mia .nav-pills .nav-item .nav-link.active, body.mia .nav-pills .nav-item .nav-link:hover {
  background-color: #f29467;
  border-color: #f29467;
  color: #fff;
}
body.mia .scrolling-table {
  border: 1px solid #f29467;
}
body.mia .scrolling-table th {
  background-color: #f29467;
  color: #fff;
}
body.mia .search .results {
  outline: 2px solid #ec1b6b;
  border-radius: 20px;
  border-radius: 20px;
}
body.mia .search .result .our-sku {
  color: #ec1b6b;
}
body.mia .search .result:hover {
  background-color: #f29467;
  color: #fff;
}
body.mia .search .result:hover * {
  color: #fff !important;
}
body.mia table.clickable tbody tr:hover td {
  color: #ec1b6b;
}
body.mia table.clickable tbody tr:hover td:first-child {
  border-left-color: #ec1b6b;
}
body.mia table tr:nth-child(2n) td, body.mia table tr:nth-child(2n) th {
  background: #daeef8;
}
body.mia .side-nav > ul > li.active > a {
  color: #4abede;
}
body.mia a:hover {
  color: #4abede;
}

body.disrupt {
  background-color: #fff;
  font-family: Poppins, sans-serif;
}
body.disrupt .container {
  width: auto;
  max-width: none;
  padding: 0px;
}
body.disrupt .logo {
  padding: 20px;
}
body.disrupt .search {
  border: 2px solid #272727;
}
body.disrupt .search .results {
  min-width: calc(100% + 4px);
  border-left: 2px solid black;
  border-right: 2px solid black;
  border-bottom: 2px solid black;
  margin-left: -2px;
  margin-right: -2px;
}
body.disrupt .top-nav {
  background-color: #fff;
}
body.disrupt .top-nav .container {
  border-bottom: 2px solid #272727;
}
body.disrupt .side-nav {
  min-height: calc(100vh - 111px);
  max-height: calc(100vh - 111px);
  overflow-y: auto;
  position: fixed;
  top: 111px;
  background-color: #111217;
  width: 300px;
  padding: 0px;
}
body.disrupt .side-nav ul {
  padding: 20px;
}
body.disrupt .side-nav > ul > li {
  font-weight: normal;
  color: #fff;
  border-bottom-color: #00abdf;
}
body.disrupt .side-nav .phone-numbers {
  padding: 20px;
  /*padding-bottom: 10px;*/
  margin-bottom: 10px;
  border-bottom: 1px solid #00abdf;
}
body.disrupt .side-nav .phone-numbers a {
  color: #fff;
}
body.disrupt .search .result:hover {
  background-color: #00abdf;
  color: #fff;
}
body.disrupt .search .result:hover * {
  color: #fff !important;
}
body.disrupt .side-nav > ul > li {
  padding: 0px;
  margin-bottom: 0px;
  color: #fff;
}
body.disrupt .side-nav > ul > li > a {
  padding: 5px;
  color: #fff;
}
body.disrupt .carousel-root {
  height: 450px;
  width: calc(100% + 80px);
  margin-left: -40px;
  margin-right: -40px;
  margin-top: -40px;
  margin-bottom: 40px;
}
body.disrupt .carousel-root .carousel {
  height: 100%;
}
body.disrupt .carousel-root .carousel .slider.animated {
  transition: all 0.35s ease-in-out !important;
}
body.disrupt .carousel-root .carousel .slider-text {
  font-size: 3.71429em;
  font-weight: bold;
  line-height: 100%;
  text-align: left;
  height: auto;
  margin-left: 40px;
}
body.disrupt .carousel-root .carousel .slider-text p {
  margin: 0px;
}
body.disrupt .carousel-root .carousel .slider-text .subtitle {
  font-size: 30px;
  font-weight: normal;
}
body.disrupt .carousel-root .carousel .slider-wrapper {
  height: 100%;
}
body.disrupt .carousel-root .carousel .slider-wrapper .slider {
  height: 100%;
}
body.disrupt .carousel-root .carousel .slider-wrapper .slider .slide {
  height: 100%;
}
body.disrupt .carousel-root .carousel .slider-wrapper .slider .slide div {
  height: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
body.disrupt .carousel-root .control-dots .dot {
  box-shadow: none;
  opacity: 0.5;
  width: 15px;
  height: 15px;
  background: #fff;
}
body.disrupt a:hover, body.disrupt .side-nav > ul > li.active > a {
  background-color: #24ceff;
  color: #fff;
}
body.disrupt .nav-tabs {
  border-bottom: 1px solid #24ceff;
  margin-bottom: 0px;
}
body.disrupt .nav-tabs .nav-link:hover {
  color: #fff;
  background-color: #24ceff;
}
body.disrupt .nav-tabs .nav-link.active {
  color: #fff;
  background-color: #24ceff;
}
body.disrupt .info-panel-body {
  border-left: 1px solid #24ceff;
  border-right: 1px solid #24ceff;
  border-bottom: 1px solid #24ceff;
  padding: 20px;
}
body.disrupt .pricing-matrix-table {
  margin-top: 0px;
}
body.disrupt .product-details-table th {
  white-space: nowrap;
}
body.disrupt .product-details-table td, body.disrupt .product-details-table th {
  /*padding: 20px;*/
  padding-left: 0px;
  padding-top: 10px;
  padding-bottom: 10px;
}
body.disrupt .main-content {
  padding: 0px 0px 0px 300px;
  margin-left: 0px;
}
body.disrupt section {
  box-shadow: none;
}
body.disrupt .product-details h2 {
  background: #111217;
  font-size: 26px;
  text-align: center;
  color: #fff;
  position: sticky;
  top: 110px;
  padding: 10px;
  font-weight: normal;
  z-index: 90;
  margin-bottom: 40px;
}
body.disrupt .product-details h3 {
  background-color: #00abdf;
  font-size: 20px;
  text-align: center;
  padding: 10px;
  color: #fff;
  font-weight: normal;
}
body.disrupt h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
body.disrupt .home-page {
  padding: 40px;
}
body.disrupt .home-page h2 {
  margin-bottom: 20px;
}
body.disrupt table.clickable tr:hover td {
  background-color: #24ceff;
  color: #fff;
}
body.disrupt .key-details table {
  border: 2px solid #00abdf;
}
body.disrupt .btn-primary {
  background-color: #111217;
}
body.disrupt .btn-primary:hover, body.disrupt .btn-primary:active {
  background-color: #111217;
  outline: 2px solid #24ceff;
  color: #24ceff;
}

/* latin-ext */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJnecmNE.woff2) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJfecg.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7Z1JlFc-K.woff2) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7Z1xlFQ.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}`, "",{"version":3,"sources":["webpack://./src/scss/main.scss","webpack://./src/scss/_mia.scss","webpack://./src/scss/_disrupt.scss"],"names":[],"mappings":"AASA;EACC,gCAAA;AARD;;AAWA;EACC,YAAA;AARD;;AAWA;EACC,WAAA;EACA,gBAAA;EACA,cAlBW;EAmBX,8BAAA;AARD;;AAWA;EACC,2BAAA;EACA,gCAAA;AARD;;AAWA;EACC,eAAA;EACA,QAAA;EACA,WAAA;EACA,aA7BgB;EA8BhB,YAAA;AARD;AAUC;EACC,YAAA;EACA,aAAA;EACA,aAAA;AARF;AAWC;EACC,YAAA;EACA,kBAAA;AATF;AAWE;EACC,eAAA;EACA,WAAA;EACA,YAAA;AATH;AAaC;EACC,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAXF;AAaE;EACC,UAAA;AAXH;AAaG;EACC,WAAA;EACA,iBAAA;AAXJ;AAaI;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAXL;AAcI;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,cA/EY;EAgFZ,oBAAA;AAZL;AAkBC;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;AAhBF;AAkBE;EACC,eAAA;EACA,cA5FY;AA4Ef;AAkBG;EACC,kBAAA;AAhBJ;AAmBG;EAEC,eAAA;EACA,kBAAA;AAlBJ;AAqBG;EACC,cAxGQ;AAqFZ;;AAyBA;EACC,YA5GgB;EA6GhB,iBAAA;AAtBD;AAwBC;EACC,WAAA;EACA,YAAA;EACA,gBAAA;AAtBF;AAwBE;EACC,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AAtBH;AAwBG;EACC,eAAA;EACA,mBAAA;AAtBJ;AAwBI;EACC,eAAA;AAtBL;AA4BC;EACC,qBAAA;EACA,cA3IU;EA4IV,aAAA;AA1BF;AA4BE;EACC,iBAAA;AA1BH;;AA+BA;EACC,iBAnJgB;EAoJhB,kBAAA;EACA,aAAA;AA5BD;;AA+BA;EACC,SAAA;EACA,iBAAA;EACA,iBAAA;AA5BD;AA8BC;EACC,eAAA;AA5BF;;AAgCA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AA7BD;;AAgCA;EACC,cAAA;EACA,uCAAA;AA7BD;;AAgCA;EACC,WAAA;EACA,uCAAA;AA7BD;;AAiCA;EACC,sBAAA;EACA,sBAAA;AA9BD;AAgCC;EAKC,gCAAA;EACA,yBAAA;AAlCF;;AAsCA;EACC,kBAAA;EACA,WAAA;EACA,eAAA;AAnCD;;AAsCA;EACC,mBAAA;AAnCD;AAqCC;EACC,aAAA;EACA,mBAAA;AAnCF;AAqCE;EACC,eAAA;EACA,gBAAA;EACA,cAAA;AAnCH;AAuCC;EACC,cAAA;AArCF;AAuCE;EACC,kBAAA;AArCH;AAuCG;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AArCJ;AAyCE;EACC,kBAAA;EACA,aAAA;EACA,WAAA;AAvCH;AA0CE;EACC,mBAAA;EACA,SAAA;AAxCH;AA2CE;EACC,YAAA;AAzCH;AA2CG;EACC,cAAA;EACA,WAAA;AAzCJ;;AA+CA;EACC,iBAAA;EACA,sBAAA;AA5CD;AA8CC;EACC,gBAAA;AA5CF;;AAgDA;EACC,kBAAA;AA7CD;;AAgDA;EACC,oBAAA;AA7CD;;AAgDA;EACC,cA/QW;EAgRX,eAAA;EACA,iBAAA;EACA,mBAAA;AA7CD;;AAgDA;EACC,aAAA;EACA,mBAAA;AA7CD;AA+CC;EACC,6BAAA;EACA,iBAAA;EACA,gBAAA;AA7CF;;AAiDA;EACC,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;AA9CD;AAgDC;EACC,cAAA;EACA,0BAAA;EACA,eAAA;AA9CF;AAiDC;EACC,YAAA;EACA,eAAA;EACA,yBAAA;EACA,cAlTU;EAmTV,aAAA;AA/CF;AAkDC;EACC,WAAA;AAhDF;;AAsDC;EACC,UAAA;EACA,WAAA;EACA,oBAAA;AAnDF;AAsDC;EACC,cAAA;EACA,YAAA;AApDF;;AAwDA;EACC,kBAAA;EACA,qBAAA;EACA,eAAA;AArDD;AAwDE;EAEC,2BAAA;EACA,wBAAA;AAvDH;AA2DC;EACC,aAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,cA5VU;EA6VV,YAAA;EACA,gBAAA;EACA,+CAAA;AAzDF;AA2DE;EACC,cAAA;AAzDH;AA6DC;EACC,aAAA;EACA,kBAAA;EACA,cA1Wa;AA+Sf;AA8DC;EACC,aAAA;EACA,eAAA;EACA,kBAAA;AA5DF;AA8DE;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA5DH;AA+DE;EACC,gCAAA;AA7DH;AAgEE;EACC,SAAA;AA9DH;AAiEE;EACC,cAlYY;EAmYZ,YAAA;AA/DH;;AAqEA;;EAEC,wBAAA;EACA,SAAA;AAlED;;AAoEA;EACC,0BAAA;AAjED;;AAsEE;EACC,kBAAA;AAnEH;AAuEC;EACC,qBAAA;AArEF;;AAyEA;EACC,kBAAA;AAtED;;AA0EC;EACC,kBAAA;EACA,YAAA;AAvEF;AAyEE;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AAvEH;;AA4EA;EACC,cAAA;AAzED;;AA4EA;EACC,kBAAA;EACA,YAAA;AAzED;AA2EC;EACC,kBAAA;EACA,YAAA;AAzEF;;AA6EA;EACC,aAAA;EACA,mBAAA;AA1ED;AA4EC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AA1EF;;AA8EA;;EAEC,gBAAA;AA3ED;;AA8EA;EACC,aAAA;AA3ED;;AA8EA;EACC,sBAAA;EACA,aAAA;EACA,+CAAA;AA3ED;;AA8EA;EACC,WAAA;AA3ED;AA6EC;EACC,8BAAA;AA3EF;AA8EC;EAEC,aAAA;AA7EF;AAiFE;EACC,eAAA;AA/EH;AAiFG;EACC,kCAAA;AA/EJ;;AAwFC;EACC,YAAA;AArFF;;AA4FC;EACC,aAAA;EACA,mBAAA;AAzFF;AA2FE;EACC,kBAAA;EACA,SAAA;EACA,gBAAA;AAzFH;AA4FE;EACC,SAAA;AA1FH;AA4FG;EACC,YAAA;EACA,mBAAA;AA1FJ;AA+FC;EACC,gBAAA;AA7FF;AAiGE;EACC,YAAA;AA/FH;;AAqGC;EACC,mBAAA;EACA,oBAAA;EACA,6BAAA;AAlGF;;AAuGC;EAEC,mBAAA;AArGF;;AAyGA;EACC,YAAA;EACA,kBAAA;EACA,cA9iBW;EA+iBX,WAAA;AAtGD;;AA2GC;EACC,YAAA;AAxGF;AA2GC;EACC,YAAA;AAzGF;;AA+GC;EACC,YAAA;AA5GF;;AAkHC;EACC,kBAAA;AA/GF;AAkHC;EACC,kBAAA;AAhHF;;AAqHC;EACC,mBAAA;AAlHF;AAqHC;EACC,gBAAA;AAnHF;;AAuHA;EACC,gBAAA;AApHD;;AAyHC;EACC,aAAA;AAtHF;AAyHC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAzmBe;EA0mBf,cAzmBa;EA0mBb,aAAA;EACA,YAAA;AAvHF;AA0HC;EACC,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kCAAA;EACA,4BAAA;AAxHF;;AA+HC;EACC,WAAA;EACA,kBAAA;AA5HF;AA+HC;EACC,kBAAA;AA7HF;AAgIC;EACC,YAAA;AA9HF;;AAkIA;EACC,eAAA;AA/HD;;AAkIA;EACC,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AA/HD;AAiIC;EACC,gBAAA;EACA,SAAA;EACA,sBAAA;AA/HF;;AAoIC;EACC,mBAAA;AAjIF;AAoIC;EACC,WAAA;EACA,gBAAA;AAlIF;;AAsIA;EACC,0BAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAnID;AAqIC;EACC,aAAA;AAnIF;;AAyIC;EACC,aAAA;EACA,mBAAA;AAtIF;AAwIE;EACC,kBAAA;AAtIH;AAyIE;EACC,SAAA;AAvIH;;AA4IA;EAAc,YAAA;AAxId;;ACnjBA;EACC,mBANgB;EAOhB,gCAAA;EACA,qBAAA;ADsjBD;ACnjBE;EACC,8BAAA;ADqjBH;ACjjBC;EACC,WAAA;EACA,YAAA;ADmjBF;AChjBC;EACC,mBDtBU;AAwkBZ;AC/iBC;EACC,yBA5Bc;EA6Bd,kBAAA;EACA,yBAAA;ADijBF;AC9iBC;EACC,yBAhCe;ADglBjB;AC9iBE;EACC,gCAAA;ADgjBH;AC5iBC;EACC,yBA1Cc;ADwlBhB;AC5iBE;EAGC,yBA/Ca;EAgDb,mCAAA;AD4iBH;ACxiBC;EACC,yBAlDW;AD4lBb;ACxiBE;EAGC,yBAvDU;EAwDV,mCAAA;ADwiBH;ACpiBC;EACC,gCAAA;ADsiBF;ACniBG;EACC,yBAlEa;ADumBjB;ACliBG;EACC,yBArES;ADymBb;AC5hBG;EACC,yBAAA;EACA,WAAA;AD8hBJ;AC5hBI;EAEC,yBAnFQ;EAoFR,qBApFQ;EAqFR,WAAA;AD6hBL;ACvhBC;EACC,yBAAA;ADyhBF;ACvhBE;EACC,yBA/FU;EAgGV,WAAA;ADyhBH;ACphBE;EACC,0BAAA;EACA,mBAAA;EACA,mBAAA;ADshBH;AClhBG;EACC,cAhHY;ADooBhB;ACjhBG;EACC,yBAjHS;EAkHT,WAAA;ADmhBJ;ACjhBI;EACC,sBAAA;ADmhBL;AC3gBE;EACC,cAjIa;AD8oBhB;AC3gBG;EACC,0BApIY;ADipBhB;ACvgBI;EAEC,mBA1IY;ADkpBjB;AClgBC;EACC,cAlJS;ADspBX;ACjgBC;EACC,cAtJS;ADypBX;;AEppBA;EAEC,sBAAA;EACA,gCAAA;AFspBD;AEppBC;EACC,WAAA;EACA,eAAA;EACA,YAAA;AFspBF;AEnpBC;EACC,aAAA;AFqpBF;AElpBC;EACC,yBAAA;AFopBF;AElpBE;EACC,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AFopBH;AEhpBC;EACC,sBAAA;AFkpBF;AEhpBE;EACC,gCAAA;AFkpBH;AE9oBC;EACC,+BAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,yBA9CU;EA+CV,YAAA;EACA,YAAA;AFgpBF;AE9oBE;EACC,aAAA;AFgpBH;AE7oBE;EACC,mBAAA;EACA,WAAA;EACA,4BA3Da;AF0sBhB;AE5oBE;EACC,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,gCAAA;AF8oBH;AE5oBG;EACC,WAAA;AF8oBJ;AEnoBG;EACC,yBAjFY;EAkFZ,WAAA;AFqoBJ;AEnoBI;EACC,sBAAA;AFqoBL;AE/nBC;EACC,YAAA;EACA,kBAAA;EACA,WAAA;AFioBF;AE/nBE;EACC,YAAA;EACA,WAAA;AFioBH;AE7nBC;EAEC,aAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AF8nBF;AE5nBE;EACC,YAAA;AF8nBH;AErnBG;EACC,4CAAA;AFunBJ;AEpnBG;EACC,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AFsnBJ;AEpnBI;EACC,WAAA;AFsnBL;AEnnBI;EACC,eAAA;EACA,mBAAA;AFqnBL;AEjnBG;EACC,YAAA;AFmnBJ;AEjnBI;EACC,YAAA;AFmnBL;AEjnBK;EACC,YAAA;AFmnBN;AEjnBM;EACC,YAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AFmnBP;AE3mBG;EACC,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AF6mBJ;AExmBC;EAEC,yBAnLe;EAoLf,WAAA;AFymBF;AErmBC;EACC,gCAAA;EACA,kBAAA;AFumBF;AEpmBG;EACC,WAAA;EACA,yBA/La;AFqyBjB;AEnmBG;EACC,WAAA;EACA,yBApMa;AFyyBjB;AEhmBC;EACC,8BAAA;EACA,+BAAA;EACA,gCAAA;EACA,aAAA;AFkmBF;AE/lBC;EACC,eAAA;AFimBF;AE7lBE;EACC,mBAAA;AF+lBH;AE5lBE;EAEC,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AF6lBH;AEzlBC;EACC,0BAAA;EACA,gBAAA;AF2lBF;AExlBC;EACC,gBAAA;AF0lBF;AEtlBE;EACC,mBA5OS;EA6OT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AFwlBH;AErlBE;EACC,yBA3Pa;EA4Pb,eAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AFulBH;AEnlBC;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;AFqlBF;AEllBC;EACC,aAAA;AFolBF;AEllBE;EACC,mBAAA;AFolBH;AEhlBC;EACC,yBAlRe;EAmRf,WAAA;AFklBF;AE9kBE;EACC,yBAAA;AFglBH;AE5kBC;EACC,yBA5RU;AF02BZ;AE5kBE;EAEC,yBAhSS;EAiST,0BAAA;EACA,cAnSc;AFg3BjB;;AExkBA,cAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gGAAA;EACA,gJAAA;AF2kBF;AEzkBA,UAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8FAAA;EACA,iMAAA;AF2kBF;AEzkBA,cAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oGAAA;EACA,gJAAA;AF2kBF;AEzkBA,UAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kGAAA;EACA,iMAAA;AF2kBF","sourcesContent":["$col-light-grey: #e4e4e4;\n$col-mid-grey: #676767;\n$col-black: #1d1d1b;\n\n$top-nav-height: 110px;\n$side-nav-width: 250px;\n\n//------------------------------------------------------------------------\n\n:root {\n\tscroll-behavior: auto !important;\n}\n\nhtml {\n\theight: 100%;\n}\n\nbody {\n\twidth: 100%;\n\tmin-height: 100%;\n\tcolor: $col-black;\n\tfont-family: Arial, sans-serif;\n}\n\n* {\n\ttransition: none !important; // Turn off all animation\n\tscroll-behavior: auto !important;\n}\n\n.top-nav {\n\tposition: fixed;\n\ttop: 0px;\n\twidth: 100%;\n\theight: $top-nav-height;\n\tz-index: 100;\n\n\t& .container {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tpadding: 20px;\n\t}\n\n\t& .logo {\n\t\theight: 100%;\n\t\tmargin-right: 20px;\n\n\t\t& img {\n\t\t\tmax-width: 100%;\n\t\t\twidth: auto;\n\t\t\theight: 100%;\n\t\t}\n\t}\n\n\t& .search-container {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmargin-left: auto;\n\n\t\t& .search {\n\t\t\twidth: 75%;\n\n\t\t\t& .search-input-container {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: relative;\n\n\t\t\t\t& input {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tborder: none;\n\t\t\t\t\tpadding: 12px 16px;\n\t\t\t\t\tborder-radius: 20px;\n\t\t\t\t}\n\n\t\t\t\t& .icon {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 15px;\n\t\t\t\t\tright: 15px;\n\t\t\t\t\tfont-size: 20px;\n\t\t\t\t\tcolor: $col-light-grey;\n\t\t\t\t\tpointer-events: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .controls {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\n\t\t& .btn {\n\t\t\tfont-size: 12px;\n\t\t\tcolor: $col-mid-grey;\n\n\t\t\t&:not(:last-child) {\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\n\t\t\t& .fa-solid,\n\t\t\t& .spinner-border {\n\t\t\t\tfont-size: 20px;\n\t\t\t\tmargin-bottom: 4px;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tcolor: $col-black;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.side-nav {\n\twidth: $side-nav-width;\n\tpadding-top: 20px;\n\n\t& > ul {\n\t\tmargin: 0px;\n\t\tpadding: 0px;\n\t\tlist-style: none;\n\n\t\t& > li {\n\t\t\tborder-bottom: 2px solid $col-light-grey;\n\t\t\tmargin-bottom: 10px;\n\t\t\tpadding-bottom: 5px;\n\t\t\tpadding-right: 10px;\n\t\t\tfont-weight: bold;\n\n\t\t\t& > ul li {\n\t\t\t\tmargin-top: 5px;\n\t\t\t\tfont-weight: normal;\n\n\t\t\t\t& > ul li {\n\t\t\t\t\tmargin-top: 5px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& a {\n\t\ttext-decoration: none;\n\t\tcolor: $col-black;\n\t\tdisplay: flex;\n\n\t\t& .icon {\n\t\t\tmargin-left: auto;\n\t\t}\n\t}\n}\n\nmain {\n\tmargin-top: $top-nav-height;\n\tposition: relative;\n\tdisplay: flex;\n}\n\n.main-content {\n\tflex: 1;\n\tmargin-left: 40px;\n\tpadding-top: 20px;\n\n\t& img {\n\t\tmax-width: 100%;\n\t}\n}\n\n.btn {\n\tborder-radius: 0px;\n\tborder: none;\n\toutline: none;\n\tbox-shadow: none;\n}\n\n.btn-primary {\n\tcolor: #ffffff;\n\tbox-shadow: 0px 0px 0px 5px transparent;\n}\n\n.btn-secondary {\n\tcolor: #fff;\n\tbox-shadow: 0px 0px 0px 5px transparent;\n\n}\n\n.btn-tertiary {\n\tbackground-color: #fff;\n\tborder: 2px solid #ccc;\n\n\t&:hover,\n\t&:focus,\n\t&:focus-visible,\n\t&:active,\n\t&.show {\n\t\tborder-color: $col-black !important;\n\t\tcolor: $col-black !important;\n\t}\n}\n\n.empty-text {\n\ttext-align: center;\n\tcolor: #aaa;\n\tfont-size: 24px;\n}\n\n.form-group {\n\tmargin-bottom: 1rem;\n\n\t& label {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t& .btn {\n\t\t\tmin-width: 24px;\n\t\t\tmax-height: 24px;\n\t\t\tfont-size: 75%;\n\t\t}\n\t}\n\n\t& .search {\n\t\tdisplay: block;\n\n\t\t& .search-input-container {\n\t\t\tposition: relative;\n\n\t\t\t& button {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 5px;\n\t\t\t\tright: 5px;\n\t\t\t\theight: 28px;\n\t\t\t\tpadding: 0px 5px;\n\t\t\t}\n\t\t}\n\n\t\t& .no-results {\n\t\t\ttext-align: center;\n\t\t\tpadding: 10px;\n\t\t\tcolor: #aaa;\n\t\t}\n\n\t\t& .results {\n\t\t\tbackground: #ffffff;\n\t\t\ttop: 40px;\n\t\t}\n\n\t\t& .search-results-button {\n\t\t\tpadding: 8px;\n\n\t\t\t& button {\n\t\t\t\tdisplay: block;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.form-label {\n\tfont-weight: bold;\n\t/*margin-bottom: 5px;*/\n\n\t& .btn {\n\t\tpadding: 4px 8px;\n\t}\n}\n\n.form-control {\n\tborder-radius: 0px;\n}\n\nfieldset {\n\tmargin-bottom: -1rem;\n}\n\nh2 {\n\tcolor: $col-black;\n\tfont-size: 24px;\n\tfont-weight: bold;\n\tmargin-bottom: 40px;\n}\n\n.control-panel {\n\tdisplay: flex;\n\talign-items: center;\n\n\t&:last-child {\n\t\tborder-top: 1px solid $col-light-grey;\n\t\tpadding-top: 20px;\n\t\tmargin-top: 20px;\n\t}\n}\n\n#root.not-logged-in {\n\tmin-height: 100vh;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: #ddd;\n\tpadding: 20px 0px;\n\n\t& img {\n\t\tdisplay: block;\n\t\tmargin: 0px auto 20px auto;\n\t\tmax-width: 100%;\n\t}\n\n\t& .panel {\n\t\twidth: 350px;\n\t\tmax-width: 100%;\n\t\tbackground-color: #ffffff;\n\t\tcolor: $col-black;\n\t\tpadding: 30px;\n\t}\n\n\t& .btn {\n\t\twidth: 100%;\n\t}\n\n}\n\n.spinner-border {\n\t&.inline {\n\t\twidth: 1em;\n\t\theight: 1em;\n\t\tborder-width: 0.15em;\n\t}\n\n\t&:not(.inline) {\n\t\tdisplay: block;\n\t\tmargin: auto;\n\t}\n}\n\n.search {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmax-width: 100%;\n\n\t& input {\n\t\t&:active,\n\t\t&:focus-visible {\n\t\t\tbox-shadow: none !important;\n\t\t\toutline: none !important;\n\t\t}\n\t}\n\n\t& .results {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\ttop: 50px;\n\t\tbackground: #ffffff;\n\t\tmin-width: 100%;\n\t\tcolor: $col-black;\n\t\tz-index: 100;\n\t\toverflow: hidden;\n\t\tbox-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1);\n\n\t\t&.active {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t& .no-results {\n\t\tpadding: 10px;\n\t\ttext-align: center;\n\t\tcolor: $col-mid-grey;\n\t}\n\n\t& .result {\n\t\tdisplay: flex;\n\t\tcursor: pointer;\n\t\tpadding: 10px 15px;\n\n\t\t& img {\n\t\t\tmax-width: 50px;\n\t\t\tmax-height: 50px;\n\t\t\tmargin-right: 10px;\n\t\t\tborder-radius: 5px;\n\t\t}\n\n\t\t&:not(:last-child) {\n\t\t\tborder-bottom: 1px solid $col-light-grey;\n\t\t}\n\n\t\t& .details {\n\t\t\tflex: 1;\n\t\t}\n\n\t\t& .category {\n\t\t\tcolor: $col-mid-grey;\n\t\t\tfloat: right;\n\t\t}\n\t}\n}\n\n// Hide arrows on input[type=number]\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n\t-webkit-appearance: none;\n\tmargin: 0;\n}\ninput[type=number] {\n\t-moz-appearance: textfield;\n}\n\n.button-panel {\n\t& .btn {\n\t\t&:not(:last-child) {\n\t\t\tmargin-right: 10px;\n\t\t}\n\t}\n\n\t& .dropdown {\n\t\tdisplay: inline-block;\n\t}\n}\n\n.dropdown-menu {\n\tborder-radius: 0px;\n}\n\n.floating-controls {\n\t& > div {\n\t\tposition: relative;\n\t\theight: 100%;\n\n\t\t& .btns {\n\t\t\tposition: absolute;\n\t\t\tleft: 100%;\n\t\t\ttop: 0px;\n\t\t\theight: 100%;\n\t\t\twidth: 30px; // TEMP\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\ntr:hover .floating-controls .btns {\n\tdisplay: block;\n}\n\n.modal-content {\n\tborder-radius: 0px;\n\tborder: none;\n\n\t& .btn-close {\n\t\tborder-radius: 0px;\n\t\tborder: none;\n\t}\n}\n\n.checkbox-label {\n\tdisplay: flex;\n\talign-items: center;\n\n\t& input {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin-right: 10px;\n\t}\n}\n\ninput[type=checkbox],\ninput[type=radio] {\n\tappearance: auto;\n}\n\n.modal-backdrop ~ .modal-backdrop {\n\tz-index: 1055;\n}\n\nsection {\n\tbackground-color: #fff;\n\tpadding: 40px;\n\tbox-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);\n}\n\ntable {\n\twidth: 100%;\n\n\t& thead {\n\t\tborder-bottom: 1px solid black;\n\t}\n\n\t& th,\n\t& td {\n\t\tpadding: 10px;\n\t}\n\n\t&.clickable {\n\t\t& tbody {\n\t\t\tcursor: pointer;\n\n\t\t\t& tr td:first-child {\n\t\t\t\tborder-left: 5px solid transparent;\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n.products-table {\n\n\t& .id-col {\n\t\twidth: 110px;\n\t}\n\n}\n\n.product-details {\n\n\t& .header {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 40px;\n\n\t\t& .photo {\n\t\t\tmargin-right: 40px;\n\t\t\tflex: 1;\n\t\t\tmax-width: 500px;\n\t\t}\n\n\t\t& .key-details {\n\t\t\tflex: 1;\n\n\t\t\t& table th {\n\t\t\t\twidth: 200px;\n\t\t\t\twhite-space: nowrap;\n\t\t\t}\n\t\t}\n\t}\n\n\t& .buttons {\n\t\tmargin-top: 40px;\n\t}\n\n\t& table {\n\t\t& th {\n\t\t\twidth: 200px;\n\t\t}\n\t}\n}\n\n.sku-details {\n\t&:not(:last-child) {\n\t\tmargin-bottom: 40px;\n\t\tpadding-bottom: 40px;\n\t\tborder-bottom: 1px solid #ccc;\n\t}\n}\n\n.product-details-table {\n\t& th,\n\t& td {\n\t\tvertical-align: top;\n\t}\n}\n\n.nav-tabs .nav-link {\n\tborder: none;\n\tborder-radius: 0px;\n\tcolor: $col-black;\n\tmargin: 0px;\n}\n\n.supplier-categories-table {\n\n\t& .business-id-col {\n\t\twidth: 100px;\n\t}\n\n\t& .num-suppliers-col {\n\t\twidth: 150px;\n\t}\n}\n\n.suppliers-table {\n\n\t& .num-products-col {\n\t\twidth: 150px;\n\t}\n\n}\n\n.nav-pills .nav-item {\n\t&:not(:last-child) {\n\t\tmargin-right: 10px;\n\t}\n\n\t& .nav-link {\n\t\tborder-radius: 0px;\n\t}\n}\n\n.page-list {\n\t&:not(:last-child) {\n\t\tmargin-bottom: 40px;\n\t}\n\n\t&:last-child {\n\t\tmargin-top: 40px;\n\t}\n}\n\ntable + .page-list {\n\tmargin-top: 40px;\n}\n\n.edit-product {\n\t\n\t& .product-photo {\n\t\theight: 215px;\n\t}\n\n\t& .no-photo {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tbackground-color: $col-light-grey;\n\t\tcolor: $col-mid-grey;\n\t\tpadding: 20px;\n\t\theight: 100%;\n\t}\n\n\t& .product-photo-inner {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tbackground-size: contain;\n\t\tbackground-position: center center;\n\t\tbackground-repeat: no-repeat;\n\t}\n\n}\n\n.export-template-product-fields-table {\n\n\t& .position-col {\n\t\twidth: 50px;\n\t\ttext-align: center;\n\t}\n\n\t& td.position-col {\n\t\tpadding: 15px 10px;\n\t}\n\n\t& .actions-col {\n\t\twidth: 150px;\n\t}\n}\n\n.import-products-table {\n\tfont-size: 10px;\n}\n\n.scrolling-table {\n\tposition: relative;\n\toverflow: auto;\n\tmax-width: 926px;\n\tmax-height: 500px;\n\n\t& th {\n\t\tposition: sticky;\n\t\ttop: -1px;\n\t\tbackground-color: #fff;\n\t}\n}\n\n.product-details {\n\t& .nav-tabs {\n\t\tmargin-bottom: 20px;\n\t}\n\n\t& .pricing-matrix-table {\n\t\twidth: 100%;\n\t\tmargin-top: 20px;\n\t}\n}\n\n.sku-list {\n\tborder-top: 1px solid #ccc;\n\tborder-bottom: 1px solid #ccc;\n\tmargin-top: 40px;\n\tmargin-bottom: 20px;\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n\n\t& .nav-item a {\n\t\tpadding: 10px;\n\t}\n}\n\n.phone-numbers {\n\n\t& .phone-number {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t& img {\n\t\t\tmargin-right: 10px;\n\t\t}\n\n\t\t& a {\n\t\t\tflex: 1;\n\t\t}\n\t}\n}\n\n.pull-right { float:right }\n\n//------------------------------------------------------------------------\n\n@import '_mia.scss';\n@import '_disrupt.scss';","﻿$col-hot-pink: #ec1b6b;\n$col-blue: #4abede;\n$col-light-blue: #daeef8;\n$col-orange: #f29467;\n\n//------------------------------------------------------------------------\n\nbody.mia {\n\tbackground: $col-light-blue;\n\tscrollbar-color: $col-hot-pink $col-black;\n\tscrollbar-width: auto;\n\n\t#root.not-logged-in {\n\t\t& .panel {\n\t\t\tborder-top: 20px solid $col-hot-pink;\n\t\t}\n\t}\n\n\t&::-webkit-scrollbar {\n\t\twidth: 12px;\n\t\theight: 12px;\n\t}\n\n\t&::-webkit-scrollbar-track {\n\t\tbackground: $col-black;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: $col-hot-pink;\n\t\tborder-radius: 0px;\n\t\tborder: 2px solid $col-black;\n\t}\n\n\t& .top-nav {\n\t\tbackground-color: $col-light-blue;\n\n\t\t& .container {\n\t\t\tborder-bottom: 2px solid $col-light-grey;\n\t\t}\n\t}\n\n\t& .btn-primary {\n\t\tbackground-color: $col-hot-pink;\n\n\t\t&:hover,\n\t\t&:active,\n\t\t&:focus {\n\t\t\tbackground-color: $col-hot-pink;\n\t\t\tbox-shadow: 0px 0px 0px 5px $col-blue;\n\t\t}\n\t}\n\n\t& .btn-secondary {\n\t\tbackground-color: $col-orange;\n\n\t\t&:hover,\n\t\t&:active,\n\t\t&:focus {\n\t\t\tbackground-color: $col-orange;\n\t\t\tbox-shadow: 0px 0px 0px 5px $col-blue;\n\t\t}\n\t}\n\n\t& .nav-tabs {\n\t\tborder-bottom: 1px solid $col-orange;\n\n\t\t& .nav-link {\n\t\t\t&:hover {\n\t\t\t\tbackground-color: $col-light-blue;\n\t\t\t}\n\n\t\t\t&.active {\n\t\t\t\tbackground-color: $col-orange;\n\t\t\t}\n\t\t}\n\t}\n\n\t& .nav-pills {\n\t\t& .nav-item {\n\n\t\t\t& .nav-link {\n\t\t\t\tbackground-color: #ffffff;\n\t\t\t\tcolor: #000;\n\n\t\t\t\t&.active,\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground-color: $col-orange;\n\t\t\t\t\tborder-color: $col-orange;\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .scrolling-table {\n\t\tborder: 1px solid $col-orange;\n\n\t\t& th {\n\t\t\tbackground-color: $col-orange;\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\n\t& .search {\n\t\t& .results {\n\t\t\toutline: 2px solid $col-hot-pink;\n\t\t\tborder-radius: 20px;\n\t\t\tborder-radius: 20px;\n\t\t}\n\n\t\t& .result {\n\t\t\t& .our-sku {\n\t\t\t\tcolor: $col-hot-pink;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: $col-orange;\n\t\t\t\tcolor: #fff;\n\n\t\t\t\t& * {\n\t\t\t\t\tcolor: #fff !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& table {\n\n\t\t&.clickable tbody tr:hover td {\n\t\t\tcolor: $col-hot-pink;\n\n\t\t\t&:first-child {\n\t\t\t\tborder-left-color: $col-hot-pink;\n\t\t\t}\n\t\t}\n\n\t\t& tr {\n\t\t\t&:nth-child(2n) {\n\t\t\t\t& td,\n\t\t\t\t& th {\n\t\t\t\t\tbackground: $col-light-blue;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .side-nav > ul > li.active > a {\n\t\tcolor: $col-blue;\n\t}\n\n\t& a:hover {\n\t\tcolor: $col-blue;\n\t}\n}\n","﻿$col-mid-blue: #00abdf;// #549AD6;\n$col-light-blue: #24ceff;\n$col-black: #111217;\n\n//----------------------------------------------------------------------\n\nbody.disrupt {\n\t//height: auto;\n\tbackground-color: #fff;\n\tfont-family: Poppins, sans-serif;\n\n\t& .container {\n\t\twidth: auto;\n\t\tmax-width: none;\n\t\tpadding: 0px;\n\t}\n\n\t& .logo {\n\t\tpadding: 20px;\n\t}\n\n\t& .search {\n\t\tborder: 2px solid #272727;\n\n\t\t& .results {\n\t\t\tmin-width: calc(100% + 4px);\n\t\t\tborder-left: 2px solid black;\n\t\t\tborder-right: 2px solid black;\n\t\t\tborder-bottom: 2px solid black;\n\t\t\tmargin-left: -2px;\n\t\t\tmargin-right: -2px;\n\t\t}\n\t}\n\n\t& .top-nav {\n\t\tbackground-color: #fff;\n\n\t\t& .container {\n\t\t\tborder-bottom: 2px solid #272727;\n\t\t}\n\t}\n\n\t& .side-nav {\n\t\tmin-height: calc(100vh - 111px);\n\t\tmax-height: calc(100vh - 111px);\n\t\toverflow-y: auto;\n\t\tposition: fixed;\n\t\ttop: 111px;\n\t\tbackground-color: $col-black;\n\t\twidth: 300px;\n\t\tpadding: 0px;\n\n\t\t& ul {\n\t\t\tpadding: 20px;\n\t\t}\n\n\t\t& > ul > li {\n\t\t\tfont-weight: normal;\n\t\t\tcolor: #fff;\n\t\t\tborder-bottom-color: $col-mid-blue;\n\t\t}\n\n\t\t& .phone-numbers {\n\t\t\tpadding: 20px;\n\t\t\t/*padding-bottom: 10px;*/\n\t\t\tmargin-bottom: 10px;\n\t\t\tborder-bottom: 1px solid $col-mid-blue;\n\n\t\t\t& a {\n\t\t\t\tcolor: #fff;\n\t\t\t}\n\t\t}\n\t}\n\n\t& .search {\n\t\t& .result {\n\t\t\t& .our-sku {\n\t\t\t\t//color: $col-hot-pink;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: $col-mid-blue;\n\t\t\t\tcolor: #fff;\n\n\t\t\t\t& * {\n\t\t\t\t\tcolor: #fff !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .side-nav > ul > li {\n\t\tpadding: 0px;\n\t\tmargin-bottom: 0px;\n\t\tcolor: #fff;\n\n\t\t& > a {\n\t\t\tpadding: 5px;\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\n\t& .carousel-root {\n\t\t//border: 10px solid red;\n\t\theight: 450px;\n\t\twidth: calc(100% + 80px);\n\t\tmargin-left: -40px;\n\t\tmargin-right: -40px;\n\t\tmargin-top: -40px;\n\t\tmargin-bottom: 40px;\n\n\t\t& .carousel {\n\t\t\theight: 100%;\n\t\t\t//& .control-prev.control-arrow:before {\n\t\t\t//\tborder-right: 8px solid #00abdf;\n\t\t\t//}\n\t\t\t//\n\t\t\t//& .control-next.control-arrow:before {\n\t\t\t//\tborder-left: 8px solid #00abdf;\n\t\t\t//}\n\n\t\t\t& .slider.animated {\n\t\t\t\ttransition: all .35s ease-in-out !important;\n\t\t\t}\n\n\t\t\t& .slider-text {\n\t\t\t\tfont-size: 3.71429em;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tline-height: 100%;\n\t\t\t\ttext-align: left;\n\t\t\t\theight: auto;\n\t\t\t\tmargin-left: 40px;\n\n\t\t\t\t& p {\n\t\t\t\t\tmargin: 0px;\n\t\t\t\t}\n\n\t\t\t\t& .subtitle {\n\t\t\t\t\tfont-size: 30px;\n\t\t\t\t\tfont-weight: normal;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .slider-wrapper {\n\t\t\t\theight: 100%;\n\n\t\t\t\t& .slider {\n\t\t\t\t\theight: 100%;\n\n\t\t\t\t\t& .slide {\n\t\t\t\t\t\theight: 100%;\n\n\t\t\t\t\t\t& div {\n\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\t\t\tbackground-position: center center;\n\t\t\t\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\talign-items: flex-start;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& .control-dots {\n\t\t\t& .dot {\n\t\t\t\tbox-shadow: none;\n\t\t\t\topacity: 0.5;\n\t\t\t\twidth: 15px;\n\t\t\t\theight: 15px;\n\t\t\t\tbackground: #fff;\n\t\t\t}\n\t\t}\n\t}\n\n\t& a:hover,\n\t& .side-nav > ul > li.active > a {\n\t\tbackground-color: $col-light-blue;\n\t\tcolor: #fff;\n\t\t//font-weight: bold;\n\t}\n\n\t& .nav-tabs {\n\t\tborder-bottom: 1px solid $col-light-blue;\n\t\tmargin-bottom: 0px;\n\n\t\t& .nav-link {\n\t\t\t&:hover {\n\t\t\t\tcolor: #fff;\n\t\t\t\tbackground-color: $col-light-blue;\n\t\t\t}\n\n\t\t\t&.active {\n\t\t\t\tcolor: #fff;\n\t\t\t\tbackground-color: $col-light-blue;\n\t\t\t}\n\t\t}\n\t}\n\n\t& .info-panel-body {\n\t\tborder-left: 1px solid $col-light-blue;\n\t\tborder-right: 1px solid $col-light-blue;\n\t\tborder-bottom: 1px solid $col-light-blue;\n\t\tpadding: 20px;\n\t}\n\n\t& .pricing-matrix-table {\n\t\tmargin-top: 0px;\n\t}\n\n\t& .product-details-table {\n\t\t& th {\n\t\t\twhite-space: nowrap;\n\t\t}\n\n\t\t& td,\n\t\t& th {\n\t\t\t/*padding: 20px;*/\n\t\t\tpadding-left: 0px;\n\t\t\tpadding-top: 10px;\n\t\t\tpadding-bottom: 10px;\n\t\t}\n\t}\n\n\t& .main-content {\n\t\tpadding: 0px 0px 0px 300px;\n\t\tmargin-left: 0px;\n\t}\n\n\t& section {\n\t\tbox-shadow: none;\n\t}\n\n\t& .product-details {\n\t\t& h2 {\n\t\t\tbackground: $col-black;\n\t\t\tfont-size: 26px;\n\t\t\ttext-align: center;\n\t\t\tcolor: #fff;\n\t\t\tposition: sticky;\n\t\t\ttop: 110px;\n\t\t\tpadding: 10px;\n\t\t\tfont-weight: normal;\n\t\t\tz-index: 90;\n\t\t\tmargin-bottom: 40px;\n\t\t}\n\n\t\t& h3 {\n\t\t\tbackground-color: $col-mid-blue;\n\t\t\tfont-size: 20px;\n\t\t\ttext-align: center;\n\t\t\tpadding: 10px;\n\t\t\tcolor: #fff;\n\t\t\tfont-weight: normal;\n\t\t}\n\t}\n\n\t& h3 {\n\t\tfont-size: 20px;\n\t\tfont-weight: bold;\n\t\tmargin-bottom: 20px;\n\t}\n\n\t& .home-page {\n\t\tpadding: 40px;\n\n\t\t& h2 {\n\t\t\tmargin-bottom: 20px;\n\t\t}\n\t}\n\n\t& table.clickable tr:hover td {\n\t\tbackground-color: $col-light-blue;\n\t\tcolor: #fff;\n\t}\n\n\t& .key-details {\n\t\t& table {\n\t\t\tborder: 2px solid $col-mid-blue;\n\t\t}\n\t}\n\n\t& .btn-primary {\n\t\tbackground-color: $col-black;\n\n\t\t&:hover,\n\t\t&:active {\n\t\t\tbackground-color: $col-black;\n\t\t\toutline: 2px solid $col-light-blue;\n\t\t\tcolor: $col-light-blue;\n\t\t}\n\t}\n}\n\n/* latin-ext */\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJnecmNE.woff2) format('woff2');\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJfecg.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7Z1JlFc-K.woff2) format('woff2');\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7Z1xlFQ.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
